module.exports = __webpack_public_path__ + "img/instagram.897d6d7f.svg";